import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { FiRefreshCcw } from "react-icons/fi";
import * as XLSX from "xlsx";
import { notify } from "../components/actions/CommonActions";
import { batchUploadFileRecreate, batchUploadFileRecreateApi, getAllRecreatedMandates } from "../services";
import moment from "moment/moment";
import ReactPaginate from "react-paginate";

export const RecreateMandate = () => {
  const [isUploadFile, setIsUploadFile] = useState(false);
  const [batchFile, setBatchFile] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isUploaded, setIsUploaded] = useState(false);
  const [recreatedMandates, setRecreatedMandates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const fileInputRef = useRef(null);
  const [batchArray, setBatchArray] = useState([])

  useEffect(() => {
    fetchRecreatedMandates();
  }, []);

  const fetchRecreatedMandates = async (
    search = "",
    date = "",
    page = 1,
    limit = 10,
  ) => {
    setIsLoading(true);
    try {
      const response = await getAllRecreatedMandates(search, date, page, limit);
      const mandates = response?.data?.data || response?.data || response || [];
      setRecreatedMandates(Array.isArray(mandates) ? mandates : []);
      setPageCount(response?.data?.totalPages || 0);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setRecreatedMandates([]);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchRecreatedMandates(searchTerm, createdAt, 1, 10);
  };
  

  const handlePageClick = async (data) => {
    setIsLoading(true);
    let selectedPage = data.selected + 1;
    setCurrentPage(selectedPage);
    await fetchRecreatedMandates(searchTerm, createdAt, selectedPage, 10);
    setIsLoading(false);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setUploadedFile(file);
    if (file) {
  const reader = new FileReader();

  reader.onload = (e) => {
    const data = e.target.result;

    const workbook = XLSX.read(data, { type: "binary" });

    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];

    // Keep your original full data array
    const dataArray = XLSX.utils.sheet_to_json(worksheet);

    // New variable for only subscriberCode values
    const subscriberCodes = dataArray
      .map((row) => row.subscriberCode)
      .filter(Boolean);

    console.log("Full Data:", dataArray);
    console.log("Subscriber Codes:", subscriberCodes);

    // Keep original state unchanged
    setBatchFile(dataArray);
    setBatchArray(subscriberCodes)

    // Use subscriberCodes separately however you want
    // setSubscriberCodes(subscriberCodes)

    setIsUploaded(dataArray.length > 0);
  };

  reader.readAsBinaryString(file);
}
  };

  

  const handleUploadFile = async () => {
    const userdata = await sessionStorage.getItem("userdata")
    let parsedData = JSON.parse(userdata)
  let sentData ={
    data: batchArray,
    user_id: parsedData?.userData?.id
  }
  
    setIsUploadFile(true);
    batchUploadFileRecreateApi(sentData)
      .then((res) => {
        if (res.status === true) {
          notify("success", "Success", res?.message);
          setIsUploadFile(false);
          setIsUploaded(false);
          setBatchFile([]);
          setBatchArray([])
          setUploadedFile(null);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          fetchRecreatedMandates();
        } else {
          notify("danger", "OOPS", "something went wrong");
          setIsUploadFile(false);
        }
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        setIsUploadFile(false);
      });
  };

  const getTableHeaders = () => {
    if (batchFile.length === 0) return [];
    return Object.keys(batchFile[0]);
  };

  return (
    <div className="container-fluid" style={{ marginTop: "20px" }}>
      <div className="d-flex justify-content-between mb-3">
        <div className="d-flex gap-2">
          <Button
            variant="primary"
            onClick={() => fileInputRef.current.click()}
            disabled={isUploadFile}
          >
            {isUploadFile ? <FiRefreshCcw className="spin" /> : "Upload Excel"}
          </Button>
          <input
            type="file"
            accept=".xlsx, .xls"
            style={{ display: "none" }}
            ref={fileInputRef}
            onChange={handleFileChange}
          />
        </div>
        <div className="d-flex gap-2">
          <Form.Control
            type="text"
            placeholder="Search by subscriber code..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            style={{ width: "200px" }}
          />
          <Form.Control
            type="date"
            placeholder="Filter by date"
            value={createdAt}
            onChange={(e) => setCreatedAt(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            style={{ width: "150px" }}
          />
          <Button
            variant="secondary"
            onClick={handleSearch}
            disabled={isLoading}
          >
            Search
          </Button>
          <Button
            variant="outline-secondary"
            onClick={() => fetchRecreatedMandates("", "")}
          >
            All
          </Button>
        </div>
      </div>

      {isUploaded && (
        <>
          <Row className="mb-3">
            <Col>
              <code className="mt-4">
                The following {batchFile?.length} mandates would be recreated
              </code>
            </Col>
            <Col className="text-end">
              <Button
                variant="secondary"
                onClick={() => {
                  setIsUploaded(false);
                  setBatchFile([]);
                  setUploadedFile(null);
                  if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                  }
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
          <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <table className="fl-table">
              <thead>
                <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                  {getTableHeaders().map((header) => (
                    <th key={header} width="11%">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              {batchFile?.length < 1 ? (
                <tbody>
                  <tr>
                    <td colSpan={getTableHeaders().length}>
                      No mandate found...
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {batchFile?.map((mandate, index) => (
                    <tr className="tr" key={index}>
                      {getTableHeaders().map((header) => (
                        <td className="gray-td" key={header}>
                          {mandate[header] !== undefined ? mandate[header] : ""}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
          <Row className="mt-3">
            <Col>
              <Button
                variant="primary"
                onClick={handleUploadFile}
                disabled={isUploadFile}
              >
                {isUploadFile ? "Uploading..." : "Submit Recreate Mandates"}
              </Button>
            </Col>
          </Row>
        </>
      )}

      {!isUploaded && (
        <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <table className="fl-table">
            <thead>
              <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                <th width="20%">Subscriber Code</th>
                <th width="20%">Old Mandate Code</th>
                <th width="20%">New Mandate Code</th>
                <th width="20%">Created At</th>
                <th width="20%">SMS Length</th>
              </tr>
            </thead>
            {isLoading ? (
              <tbody>
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              </tbody>
            ) : recreatedMandates?.length < 1 ? (
              <tbody>
                <tr>
                  <td colSpan={5}>No recreated mandates found...</td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {recreatedMandates?.map((mandate, index) => (
                  <tr className="tr" key={index}>
                    <td className="gray-td">{mandate?.subscriberCode}</td>
                    <td className="gray-td">{mandate?.oldMandateCode}</td>
                    <td className="gray-td">{mandate?.newMandateCode}</td>
                    <td className="gray-td">
                      {moment(mandate?.createdAt).format("DD MMM, YYYY")}
                    </td>
                    <td className="gray-td">{mandate?.smsLength}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={currentPage - 1}
          />
        </div>
      )}
    </div>
  );
};
